import api from './Api'

const route = '/dealership'

export default {
  get: params => api().get(`${route}`, { params: { ...params, expand: 'admin' } }),
  // view: () => api().get(route),
  view: params => api().get(`${route}/${params.id}`, { params }),
  post: (payload, params) => api().post(`${route}`, payload),
  put: (payload, params) => api().put(`${route}/${payload.id}`, payload),
  putConfig: (payload, params) => api().post(`${route}/${payload.id}/config`, payload),
  putComodatos: (payload, params) => api().post(`${route}/comodato/${params}`, payload),
  delete: payload => api().delete(`${route}/${payload.id}`),
  addImage: (id, payload) => api().post(`${route}/${id}/image`, payload),
  assignDealers: (colaboradorId, payload) => api().post(`${route}/${colaboradorId}/assign-dealers`, payload),
  removeDealers: (colaboradorId, payload) => api().post(`${route}/${colaboradorId}/remove-dealers`, payload),
  getMyAccessibleDealers: () => api().get(`${route}/my-accessible-dealers`)
  // enable: payload => api().put(`${route}/enable/${payload.id}`),
  // getStats: () => api().get(`${route}/stats`)
}
